import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Footer from "./Pages/Footer";
import Header from "./Pages/Header";

import { Outlet } from "react-router-dom";

// const router = createBrowserRouter([
//   // {
//   //   path: "/Admin/room",
//   //   element: <Rooms />,
//   // },
//   // {
//   //   path: "/Admin/roomcategory",
//   //   element: <RoomCategory />,
//   // },
//   // {
//   //   path: "/Admin/sitesetting",
//   //   element: <SiteSetting />,
//   // },
//   // {
//   //   path: "/Admin/user",
//   //   element: <User />,
//   // },
//   // {
//   //   path: "/Admin/useradd",
//   //   element: <UserAdd />,
//   // },
//   // {
//   //   path: "/Reception/booked",
//   //   element: <Booked />,
//   // },
//   // {
//   //   path: "/Reception/check-in",
//   //   element: <Checkin />,
//   // },
//   // {
//   //   path: "/Reception/check-out",
//   //   element: <Checkout />,
//   // },
//   // {
//   //   path: "/Login",
//   //   element: <Login />,
//   // },
//   // {
//   //   path: "/Aheader",
//   //   element: <Aheader />,
//   // },
//   {
//     path: "/About",
//     element: <About />,
//   },
//   {
//     path: "/Room",
//     element: <Room />,
//   },
//   {
//     path: "/Contact",
//     element: <Contact />,
//   },
//   {
//     path: "/Gallery",
//     element: <Gallery />,
//   },
//   {
//     path: "/Booking",
//     element: <Booking />,
//   },
//   {
//     path: "/Service",
//     element: <Service />,
//   },
//   // {
//   //   path: "/sidebar",
//   //   element: <Sidebar />,
//   // },
//   // {
//   //   path: "/sidebar1",
//   //   element: <Sidebar1 />,
//   // },
//   // {
//   //   path: "/Admin",
//   //   element: <Adminhome />,
//   // },
//   // {
//   //   path: "/Reception",
//   //   element: <Receptionhome />,
//   // },

//   {
//     path: "/",
//     element: <Home />,
//   },
// ]);
function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Outlet />
      </main>
<Footer/>
      {/* <RouterProvider router={router} /> */}
    </div>
  );
}

export default App;
